/* @ngInject */
export default function (Restangular) {
  return Restangular.service('bandwidthPricing');
}

